// constants.ts
export const constants = {
    FORM_SUBMIT: "Are you sure you want to submit these details?",
    FORM_DISCARD: "You have unsaved changes. Are you sure you want to discard them?",
    SUPER_ADMIN_ID:1
};
